import React from 'react';
import './ManifestLetter.css';
import { about } from '../../../constants';
import { useTranslation } from 'react-i18next';

const ManifestLetter = () => {
    
    const { t } = useTranslation();

    return (
        <section className="manifest-letter-section">
            <div className="manifest-letter-container">
                
                {/* --- LEWA KOLUMNA: List Prezesa --- */}
                <div className="ml-column president-column">
                    <div className="president-content">
                        {about.presidentLetter.content.map((paragraph, index) => (
                            <p key={index} className="president-text">
                                {t(`about.presidentLetter.content.${index}`)}
                            </p>
                        ))}
                        
                        <div className="president-signature-box">
                            <p className="closing">{t('about.presidentLetter.closing')}</p>
                            <h4 className="signature">{about.presidentLetter.signature}</h4>
                            <span className="role">{t('about.presidentLetter.role')}</span>
                        </div>
                    </div>
                </div>

                {/* --- PRAWA KOLUMNA: Manifest --- */}
                <div className="ml-column manifesto-column">
                    <div className="manifesto-box">
                        <h2 className="manifesto-title">{t('about.manifest.title')}</h2>
                        <h3 className="manifesto-subtitle">{t('about.manifest.subtitle')}</h3>
                        
                        <div className="manifesto-beliefs">
                            {/* NAPRAWIONE: Dodano tłumaczenie dla "Wierzymy, że:" */}
                            <p className="beliefs-intro">{t('about.manifest.beliefsIntro', 'Wierzymy, że:')}</p>
                            <ul>
                                {about.manifest.beliefs.map((belief, index) => (
                                    <li key={index}>{t(`about.manifest.beliefs.${index}`)}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="manifesto-conclusion">
                            {about.manifest.conclusion.map((line, index) => (
                                <p key={index}>{t(`about.manifest.conclusion.${index}`)}</p>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ManifestLetter;